import { render, staticRenderFns } from "./conversation.vue?vue&type=template&id=8e1db214&scoped=true"
import script from "./conversation.vue?vue&type=script&lang=js"
export * from "./conversation.vue?vue&type=script&lang=js"
import style0 from "./conversation.vue?vue&type=style&index=0&id=8e1db214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1db214",
  null
  
)

export default component.exports